import type { WebchatTranslations } from '.'

export const pt: WebchatTranslations = {
  'composer.placeholder': 'Digite sua mensagem...',
  'composer.sendButton.ariaLabel': 'Botão Enviar mensagem',
  'composer.voiceButton.ariaLabel': 'Botão Entrada de voz',
  'composer.fileButton.ariaLabel': 'Botão Enviar arquivo',
  'composer.messageInput.ariaLabel': 'Entrada de mensagem',

  'fileAttachment.uploadError': 'Erro no envio',
  'fileAttachment.fallbackExtension': 'Arquivo',
  'fileAttachment.removeButton.ariaLabel': 'Botão Remover arquivo',

  'header.defaultBotName': 'Bot',
  'header.expandButton.ariaLabel': 'Botão Expandir cabeçalho',
  'header.sound.enable': 'Ativar sons do chat',
  'header.sound.disable': 'Desativar sons do chat',

  'conversationHistory.title': 'Conversas',
  'conversationHistory.empty': 'Nenhuma conversa iniciada ainda',
  'conversationHistory.newConversation': 'Nova conversa',
  'conversationHistory.sentAttachment': 'Enviou um anexo',
  'conversationHistory.showButton.ariaLabel': 'Botão Mostrar conversas recentes',

  'restartConversation.title': 'Criar nova conversa',
  'restartConversation.description': 'Isso apagará a conversa atual e iniciará uma nova.',
  'restartConversation.confirm': 'Nova conversa',
  'restartConversation.cancel': 'Cancelar',
  'restartConversation.button.ariaLabel': 'Botão Reiniciar conversa',

  'closeButton.ariaLabel': 'Botão Fechar chatbot',

  'feedback.title': 'Ajude-nos a melhorar',
  'feedback.description': 'Por favor, envie seu feedback para nos ajudar a melhorar.',
  'feedback.confirm': 'Enviar feedback',
  'feedback.cancel': 'Cancelar',
  'feedback.placeholder': 'Conte-nos o que deu errado...',

  'error.configuration': 'Erro de configuração',
  'error.bot': 'Erro do bot',
  'error.network': 'Erro de rede',
  'error.disconnected': 'Desconectado',
  'error.unexpected': 'Erro inesperado',

  'dropdown.placeholder': 'Selecionar...',
}
